export default __webpack_public_path__ + "static/media/zodiac07.a3af8cde.png";